/*
 * @Author       : LQ
 * @Description  :
 * @version      : 1.0
 * @Date         : 2021-08-20 16:44:21
 * @LastAuthor   : LQ
 * @lastTime     : 2021-08-20 17:16:18
 * @FilePath     : /u-view2.0/uview-ui/libs/config/props/navbar.js
 */
import CONFIG from '@/common/config.js'
import color from '../color'
export default {
    // navbar 组件
    navbar: {
        safeAreaInsetTop: true,
        placeholder: true,
        fixed: true,
        border: false,
        leftIcon: 'arrow-left',
        leftText: '',
        rightText: '',
        rightIcon: '',
        title: '',
        bgColor: CONFIG.$bg_color,
        titleWidth: '400rpx',
        height: '44px',
		leftIconSize: 20,
		leftIconColor:'#1B1B1B',// color.mainColor,
		autoBack: true,
		titleStyle: ''
    }

}
